<mat-checkbox [(ngModel)]="accountValue.selected"
              data-cy="checkbox-account-select"
              name="account-select-checkbox">
  <span [ngClass]="{'multishare': isMultiShareSupported}">{{accountValue.description}}</span>
</mat-checkbox>

<mat-form-field id="segment-share-id">
  <input name="foreign-id"
         class="share-foreign-id"
         data-cy="input-foreign-id"
         matInput
         maxlength="300"
         (blur)="blurOnForeignId()"
         (focus)="focusOnForeignId()"
         [(ngModel)]="accountValue.foreignIdForCurrentSegment"
         [disabled]="!this.accountValue.userProvidedForeignId"
         [placeholder]="accountValue.userProvidedForeignId ? 'Remote ID' : '-automatically set-'">
  <mat-hint *ngIf="accountValue.userProvidedForeignId"
            align="end">{{accountValue.foreignIdForCurrentSegment?.length}} /
    300
  </mat-hint>
</mat-form-field>
